<div class="calendar-settings">
    <div>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col-4 ">
                    <div class="row no-gutters">
                        <div class="col-5">
                            <bcu-drop-down-cf2 [formControl]="searchForm.controls['calendarMode']" [options]="calendarModes"
                                (changed)="onCalendarModeChanged($event)" textAlign="left" [sortItems]="true">
                            </bcu-drop-down-cf2>
                        </div>
                        <div class="col-7">
                            <div class="row no-gutters">
                                <div class="col date-selectors ">
                                    <span class="date-arrow d-flex justify-content-center align-items-center ml-3"
                                        (click)="onPrevious()">
                                        <span class="i-arrow-left"></span>
                                    </span>
                                    <span class="date-arrow d-flex justify-content-center align-items-center"
                                        (click)="onNext()">
                                        <span class="i-arrow-right"></span>
                                    </span>

                                    <div class="date-text ml-2 open-icon-container" (click)="datePicker.toggle($event)">
                                        <span>{{currentDate | bcDate: 'MMM DD, YYYY' }}</span>

                                        <span *ngIf="!datePicker.isOpen"
                                            class="ic-calendar-icon ic-calendar-closed"></span>
                                        <span *ngIf="!datePicker.isOpen"
                                            class="ic-calendar-icon ic-calendar-closed-hover"></span>
                                        <span *ngIf="datePicker.isOpen"
                                            class="ic-calendar-icon ic-calendar-opened"></span>
                                        <span *ngIf="datePicker.isOpen"
                                            class="ic-calendar-icon ic-calendar-opened-hover"></span>
                                    </div>

                                    <bcu-date-select #datePicker [formControl]="searchForm.controls['date']"
                                        [canSelectPastDates]="true"></bcu-date-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-8">
                    <div class="row flex-row-reverse  no-gutters">

                        <div class="col-auto">

                            <div class="ml-3">
                                <button *ngIf="!advancedFilters" type="button" (click)="changeTypeOfFilters()"
                                    class="btn bc-button btn-filters btn-sm min-width-150" translate [disabled]="!context">
                                    CalendarSettings.BtnShowFilters
                                </button>
                                <button *ngIf="advancedFilters" type="button" (click)="changeTypeOfFilters()"
                                    class="btn bc-button btn-filters btn-sm min-width-150" translate>
                                    CalendarSettings.BtnHideFilters
                                </button>
                            </div>
                        </div>

                        <div class="col-auto " *ngIf="showClubsDropdown()">
                            <div class="ml-3 min-width-210">
                                <bcu-drop-down-cf2 maxHeigth="450" placeHolder="All clubs" [multiple]="false"
                                    [formControl]="searchForm.controls['clubId']" displayKey="shortName" valueKey="id"
                                    [options]="clubs" textAlign="left" [sortItems]="true"></bcu-drop-down-cf2>
                            </div>
                        </div>

                        <div class="col-auto text-right">

                            <div *ngIf="isWeek" class="btn-group min-width-150" role="group"
                                [showIfPrivileges]="'GroupClasses.canManageClasses'"
                                [clubIds]="searchForm.controls['clubId'].value">
                                <button type="button" class="btn bc-button dropdown-toggle" data-toggle="dropdown">
                                    Copy Week
                                </button>
                                <div class="dropdown-menu">
                                    <a *ngFor="let copyWeekOption of copyWeekOptions"
                                        (click)="onCopySchedule(copyWeekOption.value)"
                                        class="dropdown-item clickable">{{copyWeekOption.name}}</a>
                                </div>
                            </div>

                            <div *ngIf="isDay" class="btn-group min-width-150" role="group"
                                [showIfPrivileges]="'GroupClasses.canManageClasses'"
                                [clubIds]="searchForm.controls['clubId'].value">
                                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown">
                                    Copy Day
                                </button>
                                <div class="dropdown-menu">
                                    <a *ngFor="let copyDayOption of copyDayOptions"
                                        (click)="onCopySchedule(copyDayOption.value)"
                                        class="dropdown-item clickable">{{copyDayOption.name | translate : {weekday: searchForm.controls['date'].value | bcDate : 'dddd'} }}</a>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-2" *ngIf="advancedFilters">

                <div class="align-self-center align-items-center pl-2">
                    <div class="switch-container">
                        <ui-switch [checked]="searchForm.controls['substitutedOnly'].value"
                            (change)="onlySubstitutedChanged($event)" class="switch" color="#346ABC" size="small"
                            switchColor="#E5E5E5">
                        </ui-switch>
                        <span class="ml-1 check-text"
                            translate>CalendarSettings.SubstitutionsOnly</span>
                    </div>
                </div>

                <div class="ml-3 min-width-210">
                    <bcu-group-drop-down maxHeigth="450" placeHolder="All categories"
                        [formControl]="searchForm.controls['categories']" [multiple]="true" groupByKey="classTypeName"
                        [options]="categories" valueKey="code" displayKey="name">
                    </bcu-group-drop-down>
                </div>


                <div class="ml-3 min-width-150 locations-select">

                    <bcu-group-drop-down maxHeigth="450" placeHolder="All locations"
                        [displayGroupFunc]="locationGroupDisplayNameFunc"
                        [formControl]="searchForm.controls['locationIds']" [multiple]="true" groupByKey="type"
                        [options]="locations" valueKey="id" displayKey="name" >
                    </bcu-group-drop-down>
                </div>

            </div>
        </form>
    </div>
</div>
